import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  ViewEncapsulation,
} from '@angular/core';
import { IonMenu } from '@ionic/angular/standalone';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faCircleChevronLeft,
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'lyceo-ui-more-menu',
  templateUrl: './more-menu.component.html',
  styleUrls: ['./more-menu.component.scss'],
  imports: [IonMenu, FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'lyceo-ui-more-menu',
  },
})
export class MoreMenuComponent {
  public readonly contentId: InputSignal<string> = input.required();
  public readonly menuId: InputSignal<string> = input('more-menu');
  public readonly closeMenu: OutputEmitterRef<void> = output();

  protected readonly faCircleChevronLeft: IconDefinition = faCircleChevronLeft;
}
